/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { Table } from '@tiptap/extension-table'
import { tableNodeConfig } from './table-node-config'

const CustomTable = Table.extend(tableNodeConfig)
export { CustomTable }
